import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import SettingListItem from '../SettingListItem';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const Terms = () => {

    const {openSettings} = useTheme();

    const [activeRecord, setActiveRecord] = useState(null);
    const {getAcademicTerms, academicTerms} = useConfig();


    useEffect(()=>{
        getAcademicTerms();
    }, [])

    const handleNew = ()=>{
        openSettings("New Academic Term", "NewAcademicTerm");
    }

    const handleEdit = ()=>{
        openSettings("Edit Class Level", "EditAcademicTerm", activeRecord);
    }

   
    const menu = ()=>{

        return(<>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-plus"> </i><span>Create Term</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit"> </i><span>Edit Term</span>
            </button>
        </>)
    }

    return (
        <SettingContainer
            title="Academic Terms"
            icon="fa fa-calendar"
            Menu={menu}
            >
      
            {Array.isArray(academicTerms) && <ul className="list-group">
                {academicTerms.map((item) => (
                    
                    <SettingListItem
                        key={item.term_id} 
                        iconName='fa fa-cog'
                        itemName={item.term}
                        onSelect={()=>setActiveRecord(item)}
                        active={item.term_id === activeRecord?.term_id}
                    />
                        
                ))}
            </ul>}
            {academicTerms === '404' && <Notification message="No academic term found" />}
            {!academicTerms && <ActivityLoader />}
       </SettingContainer>

      
    );
};

export default Terms;
